// extracted by mini-css-extract-plugin
export default {"userAccount":"UserPanelPage_userAccount__029ap"};